module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp23_8003.2d1e5759.png";